import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Question from 'pages/question/Question';

const QuestionRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Question />} />
    </Routes>
  );
};

export default QuestionRouter;
